import type { IHelpersProps } from "../../types";
import { Computer, LiveHelp, Smartphone } from "@mui/icons-material";
import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material";

export default function Helpers(props: IHelpersProps) {
  const { instructions, FAQ, styles, handleOpenFile } = props;

  return (
    <>
      <Typography component="h1" variant={"h6"} textAlign="center">
        {instructions}
      </Typography>

      <Toolbar sx={styles.box}>
        <Tooltip title="Mobile guide">
          <IconButton onClick={handleOpenFile} id="MOI">
            <Smartphone />
          </IconButton>
        </Tooltip>

        <Tooltip title="Computer guide">
          <IconButton onClick={handleOpenFile} id="PCI">
            <Computer />
          </IconButton>
        </Tooltip>
      </Toolbar>

      <Typography component="h1" variant={"h6"} textAlign="center">
        {FAQ}
      </Typography>

      <Toolbar sx={styles.box}>
        <Tooltip title="Survivor FAQS">
          <IconButton onClick={handleOpenFile} id="SFAQ">
            <LiveHelp />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </>
  );
}
